export const ROUTE_PATHS = {
    REQUEST_GPID_FOR_NON_EMPLOYEE: "/gpid-non-employee",
    MY_IDM: "/myidmPortal"
}

// REACT_APP_VERSION_CONSTANT should be string value
export const REACT_APP_VERSION_CONSTANT = "1";